import * as i0 from '@angular/core';
import { inject, Injectable } from '@angular/core';
import { PRECARITY_LEVEL_WEB_SERVICE, CONTEXT_SESSION_TOKEN_FALSE } from '@effy-tech/angular-common/web-service';
import * as i1 from '@angular/common/http';

var PrecarityLevel;
(function (PrecarityLevel) {
    PrecarityLevel["Standard"] = "standard";
    PrecarityLevel["Intermediate"] = "intermediate";
    PrecarityLevel["Modest"] = "modest";
    PrecarityLevel["VeryModest"] = "very_modest";
    PrecarityLevel["High"] = "high";
    PrecarityLevel["HighIncome"] = "high_income";
})(PrecarityLevel || (PrecarityLevel = {}));

class PrecarityService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.precarityLevel = inject(PRECARITY_LEVEL_WEB_SERVICE);
    }
    fetchTaxRevenue(req) {
        const reqAsQueryString = Object.keys(req)
            .map(key => key + '=' + req[key])
            .join('&');
        return this.httpClient.get(`${this.precarityLevel.taxRevenue}?${reqAsQueryString}`, {
            context: CONTEXT_SESSION_TOKEN_FALSE,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.13", ngImport: i0, type: PrecarityService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.13", ngImport: i0, type: PrecarityService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.13", ngImport: i0, type: PrecarityService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

/**
 * Generated bundle index. Do not edit.
 */

export { PrecarityLevel, PrecarityService };
